// eslint-disable-next-line import/prefer-default-export
export const namespace = 'features.settings.long_form_templates.index';
